module.exports = __webpack_public_path__ + "img/pda.8562be74.jpg";